import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ value, onChange, id, "data-testid": testId, placeholder, className = "", ...rest }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        id={id}
        data-testid={testId}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`pr-10 ${className}`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? t("auth.hide_password") : t("auth.show_password")}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 p-1"
        tabIndex={-1}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}

export function PasswordRules({ value }) {
  const { t } = useTranslation();
  const rules = [
    ["pw_rule_len", (p) => p.length >= 10],
    ["pw_rule_upper", (p) => /[A-Z]/.test(p)],
    ["pw_rule_lower", (p) => /[a-z]/.test(p)],
    ["pw_rule_num", (p) => /[0-9]/.test(p)],
    ["pw_rule_spec", (p) => /[^A-Za-z0-9]/.test(p)],
  ];
  return (
    <ul className="text-xs space-y-1 mt-2">
      {rules.map(([k, fn]) => (
        <li key={k} className={`flex items-center gap-1.5 ${fn(value || "") ? "text-emerald-600" : "text-slate-400"}`}>
          <span className={`w-1.5 h-1.5 rounded-full ${fn(value || "") ? "bg-emerald-500" : "bg-slate-300"}`} /> {t(`auth.${k}`)}
        </li>
      ))}
    </ul>
  );
}

export const passwordValid = (p) =>
  (p || "").length >= 10 && /[A-Z]/.test(p) && /[a-z]/.test(p) && /[0-9]/.test(p) && /[^A-Za-z0-9]/.test(p);
